<template>
  <div class="accident-party">
    <div
      v-if="!isDisabled.value"
      class="party-controller1"
    >
      <span
        class="partyBtn btn1"
        @click="addParty"
      >
        新增当事人
      </span>
      <span
        class="partyBtn btn2"
        @click="deleteParty"
      >
        删除当事人
      </span>
    </div>
    <el-tabs
      :value="activeParty"
      :class="{
        'current-faild': validFaildIndexs.includes(activeParty * 1)
      }"
      @input="$emit('update:activeParty', $event)"
    >
      <el-tab-pane
        v-for="(party, index) in accidentPartyList"
        :key="index"
        :name="index + ''"
      >
        <template #label>
          <span :class="{ 'valid-faild': validFaildIndexs.includes(index) }">{{
            "当事人-" +
              (index + 1) +
              (validFaildIndexs.includes(index) ? "*" : "")
          }}</span>
        </template>
        <party-photos
            :accident-partys="accidentPartyList"
            :active-party.sync="activeParty"
          />
        <accident-party-form
          ref="partyForm"
          :party="party"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import AccidentPartyForm from './AccidentPartyForm';
import PartyPhotos from "../components/PartyPhotos";
export default {
  components: { AccidentPartyForm,PartyPhotos },
  inject: { isDisabled: { default: () => ({ value: false }) } },
  props: {
    accidentPartyList: {
      type: Array,
      required: true
    },
    activeParty: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      validFaildIndexs: []
    };
  },
  methods: {
    validate() {
      this.validFaildIndexs = [];
      return Promise.all(
        this.$refs.partyForm.map((partyForm, index) =>
          partyForm.validate().catch(err => {
            this.validFaildIndexs.push(index);
            throw err;
          })
        )
      ).then(() => {
        if (this.validFaildIndexs.length > 0) {
          this.$emit('update:activeParty', this.validFaildIndexs[0] + '');
        }
      });
    },
    addParty() {
      this.$emit(
        'update:activeParty',
        this.accidentPartyList.push({}) - 1 + ''
      );
    },
    deleteParty() {
      if (this.accidentPartyList.length < 2) {
        this.$message.warning('至少有应有一个当事人');
        return;
      }
      // 删除最后一个当事人的情况，tab前移
      const lastIndex = this.accidentPartyList.length - 2;
      const activeIndex = this.activeParty * 1;
      if (activeIndex > lastIndex) {
        this.$emit('update:activeParty', lastIndex + '');
      }
      let deleteIsFaild = false;
      this.validFaildIndexs = this.validFaildIndexs.reduce((acc, cur) => {
        if (cur === activeIndex) {
          deleteIsFaild = true;
          return acc;
        }
        if (cur > activeIndex && deleteIsFaild) {
          acc.push(cur - 1);
        } else {
          acc.push(cur);
        }
        return acc;
      }, []);

      this.accidentPartyList.splice(activeIndex, 1);
    }
  }
};
</script>
<style lang="scss">
.accident-party {
  padding: 0;
  position: relative;
  .el-tabs__nav-scroll {
    margin-right: 180px;
  }
  .el-tabs__nav-next {
    right: 180px;
  }

  .party-controller1 {
    position: absolute;
    right: 20px;
    top: 30px;
    padding-left: 20px;
    z-index: 5;
    .partyBtn {
      display: inline-block;
      width: 160px;
      height: 48px;
      line-height: 48px;
      border-radius: 4px;
      text-align: center;
      cursor: pointer;
    }
    .btn1 {
        color: #0EBD35;
        background: rgba(14, 189, 53, 0.1);
        border: 1px solid #0EBD35;
        margin-right: 15px;
      }
      .btn2 {
        color: #FF7D00;
        background: rgba(255, 125, 0, 0.1);
        border: 1px solid #FF7D00;
      }
  }

  .current-faild {
    .el-tabs__active-bar {
      background: #ff4949;
    }
  }
  .valid-faild {
    color: #ff4949;
  }
}
</style>
